import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for singleProfile query
 */
export interface SingleProfileVariables {
  id: string;
}

/**
 * User structure within single profile
 */
export interface SingleProfileUser {
  id: string;
  username: string;
  email: string;
}

/**
 * Media group node structure
 */
export interface SingleProfileMediaGroupNode {
  id: string;
  name: string;
}

/**
 * Media group edge structure
 */
export interface SingleProfileMediaGroupEdge {
  node: SingleProfileMediaGroupNode;
}

/**
 * Media groups connection structure
 */
export interface SingleProfileMediaGroupsConnection {
  edges: SingleProfileMediaGroupEdge[];
}

/**
 * Permissions group structure in single profile
 */
export interface SingleProfilePermissionsGroup {
  id: string;
  name: string;
  mediaGroups: SingleProfileMediaGroupsConnection;
}

/**
 * Media permission node in single profile
 */
export interface SingleProfileMediaPermissionNode {
  id: string;
  canEdit: boolean;
  canShare: boolean;
  canDownload: boolean;
  canDelete: boolean;
  hires: boolean;
  permissionsGroup: SingleProfilePermissionsGroup;
}

/**
 * Media permission edge in single profile
 */
export interface SingleProfileMediaPermissionEdge {
  node: SingleProfileMediaPermissionNode;
}

/**
 * Media permission set connection in single profile
 */
export interface SingleProfileMediaPermissionSetConnection {
  edges: SingleProfileMediaPermissionEdge[];
}

/**
 * Single profile structure
 */
export interface SingleProfile {
  user: SingleProfileUser;
  firstName: string | null;
  lastName: string | null;
  role: string | null;
  phoneNumber: string | null;
  companyName: string | null;
  mediapermissionSet: SingleProfileMediaPermissionSetConnection;
}

/**
 * Response structure for singleProfile query
 */
export interface SingleProfileResponse {
  profile: SingleProfile;
}

const singleProfile: DocumentNode = gql`
  query single_profile($id: ID!) {
    profile(id: $id) {
      user {
        id
        username
        email
      }
      firstName
      lastName
      role
      phoneNumber
      companyName
      mediapermissionSet {
        edges {
          node {
            id
            canEdit
            canShare
            canDownload
            canDelete
            hires
            permissionsGroup {
              id
              name
              mediaGroups {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default singleProfile;
